import React, { useState, useEffect, Fragment } from "react";
import { Button, Row, Col, Image } from "react-bootstrap";
import {
  getFavChains,
  getCrusines,
  getFavPlaces,
  getDietaryPref,
  getAllergies,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const ViewUser = (props) => {
  const [ShowTab, setShowTab] = useState("1");
  const [checkedBox, setCheckedBox] = useState(false);
  const handleShowTab = (e) => setShowTab(e);

  const [favourite, setFavourite] = useState([]);

  const onErrorGetFavChain = () => { };
  const onSuccessGetFavChain = (data) => {
    let favChains = [];

    for (var i = 0; i < data.length; i++) {
      if (props.data.selected_chain.includes(data[i]._id)) {
        favChains.push({
          id: data[i]._id,
          icon: data[i].icon,
          name: data[i].title,
        });
      }
    }
    setFavourite(favChains);
  };
  const [popularCuisines, setPopularCrusines] = useState([]);
  const onSuccessGetCrusines = (data) => {
    var crusines = [];

    for (var i = 0; i < data.length; i++) {
      if (props.data.selected_cuisine.includes(data[i]._id))
        crusines.push(data[i].title);
    }
    setPopularCrusines(crusines);
  };

  const [favPlaces, setFavPlaces] = useState([]);

  const onErrorGetCruisnes = () => { };

  const onSuccessGetFavPlaces = (data) => {
    let fav = [];
    for (let i = 0; i < data.length; i++) {
      if (props.data.favourite_places.includes(data[i]._id)) {
        fav.push(data[i].title);
      }
    }
    setFavPlaces(fav);
  };

  const onErrorGetFavPlaces = () => { };

  const [dietaryPref, setDietaryPref] = useState([]);

  const onSuccessGetDietaryPref = (data) => {
    let diet = [];
    for (let i = 0; i < data.length; i++) {
      if (props.data.dietary_preferences.includes(data[i]._id)) {
        diet.push(data[i].title);
      }
    }

    setDietaryPref(diet);
  };

  const onErrorGetDietaryPref = () => { };
  const [allergies, setAllergies] = useState([]);

  const onSuccessAllergies = (data) => {
    let allergy = [];

    for (let i = 0; i < data.length; i++) {
      if (props.data.do_you_have_allergies.includes(data[i]._id)) {
        allergy.push(data[i].title);
      }
    }
    setAllergies(allergy);
  };

  const onErrorGetAllergies = () => { };

  useEffect(() => {
    props.getCrusines(onSuccessGetCrusines, onErrorGetCruisnes);
    props.getFavPlaces(onSuccessGetFavPlaces, onErrorGetFavPlaces);
    props.getFavChains(onSuccessGetFavChain, onErrorGetFavChain);
    props.getDietaryPref(onSuccessGetDietaryPref, onErrorGetDietaryPref);
    props.getAllergies(onSuccessAllergies, onErrorGetAllergies);
  }, []);

  return (
    <>
      <div>
        <div className="py-4 d-flex flex-wrap align-items-center justify-content-between">
          <Button
            variant="link"
            onClick={(e) => handleShowTab("1")}
            className={`px-0 mr-4 text-grayLink f15-500 ${ShowTab === "1" ? "active" : ""
              }`}
          >
            Personal
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("2")}
            className={`px-0 mr-4 text-grayLink f15-500 ${ShowTab === "2" ? "active" : ""
              }`}
          >
            About
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("3")}
            className={`px-0 mr-4 text-grayLink f15-500 ${ShowTab === "3" ? "active" : ""
              }`}
          >
            Special occasions
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("4")}
            className={`px-0 mr-4 text-grayLink f15-500 ${ShowTab === "4" ? "active" : ""
              }`}
          >
            Personal preferences
          </Button>
          <Button
            variant="link"
            onClick={(e) => handleShowTab("5")}
            className={`px-0 text-grayLink f15-500 ${ShowTab === "5" ? "active" : ""
              }`}
          >
            Favourite hotel/restaurants
          </Button>
        </div>
        {ShowTab === "1" && (
          <div>
            <Row>
              <Col md={4}>
                <div className="opacity5 f13-400 mb-1">Phone Number</div>
                <div className="f15-700 mb-3">
                  {props.data?.mobile_number}
                </div>
                <div className="opacity5 f13-400 mb-1">Country</div>
                <div className="f15-700 mb-3 text-capitalize">
                  {props.data?.country || 'N/A'}
                </div>
              </Col>
              <Col md={4}>
                <div className="opacity5 f13-400 mb-1">Email</div>
                <div className="f15-700 mb-3">{props.data.email || 'N/A'}</div>
                <div className="opacity5 f13-400 mb-1">State</div>
                <div className="f15-700 mb-3 text-capitalize">{props.data.state || 'N/A'}</div>
              </Col>
              <Col md={4}>
                <div className="opacity5 f13-400 mb-1">Password</div>
                <div className="f15-700 mb-3">{'********'}</div>
                <div className="opacity5 f13-400 mb-1">City</div>
                <div className="f15-700 mb-3 text-capitalize">{props.data.city || 'N/A'}</div>
              </Col>
            </Row>
          </div>
        )}
        {ShowTab === "2" && (
          <div>
            <Row>
              <Col lg={8}>
                <Row>
                  <Col md={6}>
                    <div className="opacity5 f13-400 mb-1">Language</div>

                    <div className="f15-700 mb-3 text-capitalize">
                      {props?.data?.language || 'N/A'}
                    </div>
                    <div className="opacity5 f13-400 mb-1">Anniversary</div>
                    <div className="f15-700 mb-3">
                      {props.data.anniversary_day ? (
                        //nth(parseInt(props.data.birthday_day))
                        <>
                          {moment
                            .localeData()
                            .ordinal(parseInt(props.data.anniversary_day))}{" "}
                          {moment.months(props.data.anniversary_month - 1)}
                        </>
                      ) : (
                        <>N/A</>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="opacity5 f13-400 mb-1">Gender</div>
                    <div className="f15-700 mb-3 text-capitalize">
                      {props.data.gender || 'N/A'}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={4}>
                <div className="opacity5 f13-400 mb-1">Birthday</div>
                <div className="f15-700 mb-3">
                  {props.data.birthday_day ? (
                    //nth(parseInt(props.data.birthday_day))
                    <>
                      {moment
                        .localeData()
                        .ordinal(parseInt(props.data.birthday_day))}{" "}
                      {moment.months(props.data.birthday_month - 1)}
                    </>
                  ) : (
                    <>N/A</>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        )}
        {ShowTab === "3" && (
          <div>
            <Row>
              {props.data.occasion.length === 0 ? <> N/A</> : <> </>}
              {props.data.occasion.map((occasion, index) => (
                <Col md={6} key={index}>
                  <div className="f15-700">{occasion.special_occasion}</div>
                  <div className="f15-700 mb-2">
                    {" "}
                    {moment
                      .localeData()
                      .ordinal(parseInt(occasion.special_occasion_day))}{" "}
                    {moment.months(occasion.special_occasion_month - 1)}
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
        {ShowTab === "4" && (
          <div>
            <Row>
              <Col md={6}>
                <div className="opacity5 f13-400 mb-1">Days eats out</div>
                <div className="f15-700 mb-4">
                  {/* {props.data.day_you_eat_out.map((day, index) => (
                    <Fragment key={index}> {day},</Fragment>
                  ))} */}
                  {props.data?.day_you_eat_out?.length ? <Fragment>{props.data?.day_you_eat_out?.join(', ')}</Fragment> : <Fragment>N/A</Fragment>}
                </div>
              </Col>
              <Col md={6}>
                <div className="opacity5 f13-400 mb-1">Cuisines</div>
                <div className="f15-700 mb-4">
                  {/* {popularCuisines.map((item, index) => (
                    <Fragment key={index}>{item.name} , </Fragment>
                  ))} */}
                  {popularCuisines?.length ? <Fragment>{popularCuisines?.join(', ')}</Fragment> : <Fragment>N/A</Fragment>}
                </div>
              </Col>
              <Col md={6}>
                <div className="opacity5 f13-400 mb-1">Dietary preferences</div>
                <div className="f15-700 mb-4">
                  {/* {dietaryPref.map((item, index) => (
                    <Fragment key={index}>{item.name} , </Fragment>
                  ))} */}
                  {dietaryPref?.length ? <Fragment>{dietaryPref?.join(', ')}</Fragment> : <Fragment>N/A</Fragment>}
                </div>
              </Col>
              <Col md={6}>
                <div className="opacity5 f13-400 mb-1">Allergic foods</div>
                <div className="f15-700 mb-4">
                  {/* {allergies.map((item, index) => (
                    <Fragment key={index}>{item.name} , </Fragment>
                  ))} */}
                  {allergies?.length ? <Fragment>{allergies?.join(', ')}</Fragment> : <Fragment>N/A</Fragment>}
                </div>
              </Col>
              <Col md={6}>
                <div className="opacity5 f13-400 mb-1">Services type</div>
                <div className="f15-700 mb-4">
                  {/* {favPlaces.map((item, index) => (
                    <Fragment key={index}>{item.name} , </Fragment>
                  ))} */}
                  {favPlaces?.length ? <Fragment>{favPlaces?.join(', ')}</Fragment> : <Fragment>N/A</Fragment>}
                </div>
              </Col>
            </Row>
          </div>
        )}
        {ShowTab === "5" && (
          <div>
            <Row>
              {favourite.length === 0 ? (
                <Col lg={3} md={4} sm={6} className="text-center">
                  N/A
                </Col>
              ) : (
                <></>
              )}
              {favourite.map((place, index) => (
                <Col lg={3} md={4} sm={6} className="text-center" key={index}>
                  <Image
                    className="enRadius5 w-100"
                    //src={require("../../../../assets/images/UserManagement/fhr4.png")}
                    className="enFHRIMG"
                    src={place.icon}
                    alt="View"
                    title="View"
                    fluid
                  />
                  <div className="f15-700 my-2">{place.name}</div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </>
  );
};

ViewUser.propTypes = {
  auth: PropTypes.object.isRequired,
  getFavChains: PropTypes.func.isRequired,
  getCrusines: PropTypes.func.isRequired,
  getFavPlaces: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getFavChains,
  getCrusines,
  getFavPlaces,
  getDietaryPref,
  getAllergies,
})(ViewUser);
